import { useState } from 'react'
import {
    EstablishmentPicturesResponse,
    CreateEstablishmentPicturesRequest,
} from '../../resources/establishment/types'
import { mutations } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'

export const useEstablishmentPicturesCreate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const createEstablishmentPictures = (
        payload: CreateEstablishmentPicturesRequest,
    ): Promise<EstablishmentPicturesResponse> => {
        setInProgress(true)
        return mutations
            .createEstablishmentPictures(payload)
            .then((response) => {
                dispatch(actions.setEstablishmentPictures(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        createEstablishmentPictures,
        inProgress,
    }
}
